import React, { useEffect, useState } from "react";
import { FaMoneyBillWave, FaAlignLeft } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import CustomInput from "../components/customInput";
import { Alert, Avatar, Chip, FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useWallet } from "../api/hooks/useWallet";
import { useGetBanks, useLiquidationRequest, useVerifyAccount, useVerifyWalletAccount } from "../api/hooks/usePayment";
import CustomButton from "../components/customButton";
import { useNavigate } from "react-router-dom";

const LiquidationRequest = () => {
  const [formErrors, setFormErrors] = useState({
    liquidatble_wallet_number_or_uuid: "",
    liquidation_type: "",
    liquidatble_amount: "",
    liquidated_fund_destination: "",
    liquidatble_description: "",
    fund_destination_wallet_number_or_uuid: "",
    fund_destination_wallet_account_name: "",
    fund_destination_bank_uuid: "",
    fund_destination_bank_account_number: "",
    fund_destination_bank_account_name: "",
    transaction_pin: "",
  });

  const [transferError, setTransferError] = useState("");

  const navigate = useNavigate();


  const [accountName, setAccountName] = useState("");
  const [banks, setBanks] = useState([]);
  const { isLoading: isBanksLoading, data: banksData } = useGetBanks();

  const liquidationMutation = useLiquidationRequest();


  const [formData, setFormData] = useState({
    liquidatble_wallet_number_or_uuid: "",
    liquidation_type: "",
    liquidatble_amount: "",
    fund_destination_wallet_account_name: "",
    liquidated_fund_destination: "",
    liquidatble_description: "",
    fund_destination_wallet_number_or_uuid: "",
    fund_destination_bank_uuid: "",
    fund_destination_bank_account_number: "",
    fund_destination_bank_account_name: "",
    transaction_pin: "",
  });

  const [wallets, setWallets] = useState([]);

  const [selectedWallet, setSelectedWallet] = useState("");

  const { isLoading: isWalletLoading, data: walletsData, } = useWallet();

  const {
    // @ts-ignore
    data: accountVerifyData,
    isFetching: isAccountVerifying,
    // @ts-ignore
    error: accountVerifyError,
    refetch: verifyAccount,
  } = useVerifyAccount(formData.fund_destination_bank_account_number, formData.fund_destination_bank_uuid);


  const verifyWalletMutation = useVerifyWalletAccount(formData?.fund_destination_wallet_number_or_uuid);



  useEffect(() => {
    if (!banksData) return;

    let allBanks = [];

    banksData.data.forEach((element) => {
      allBanks.push({ value: element.id, label: element.name });
    });

    setBanks(allBanks);
  }, [banksData]);


  useEffect(() => {
    if (!liquidationMutation.data) return;

    console.log(liquidationMutation.data, "bank transfer thing");


    if (liquidationMutation.data.status) {

      console.log(liquidationMutation.data, "This is the main thing");
      console.log(liquidationMutation.data.data.message, "This is the main thing");

      navigate("/success-page", { state: { title: "Liquidation request sent", message: liquidationMutation.data.data.message } })

    } else {
      setTransferError(
        liquidationMutation.data.message || "Transfer processing failed"
      );
    }
  }, [liquidationMutation.data]);

  const handleRequest = async () => {
    if (!formData.transaction_pin) {
      setTransferError("Please enter your transaction PIN");
      return;
    }



    const newPayload = formData;

    if (formData.liquidated_fund_destination == "nip") {
      delete newPayload.fund_destination_wallet_number_or_uuid
    }

    if (formData.fund_destination_wallet_account_name == "") {
      setTransferError("Please enter a valid wallet account");
      return;
    }

    setTransferError("");

    console.log(newPayload, "New payload");

    liquidationMutation.mutate(newPayload);
  };

  const liquidationTypes = [
    { label: "Full Wallet Balance", value: "full-wallet-balance" },
    { label: "Partial Wallet Balance", value: "partial-wallet-balance" },
  ];

  const destinationTypes = [
    { label: "Wallet", value: "wallet" },
    { label: "NIP (Bank)", value: "nip" },
  ];


  useEffect(() => {

    if (!verifyWalletMutation.data) return;

    console.log(verifyWalletMutation.data, "Veryfing mutation");


    if (verifyWalletMutation.data.status) {
      setFormData({
        ...formData,
        fund_destination_wallet_account_name: verifyWalletMutation.data.data?.wallet_name,
      })
      return;
    }

  }, [verifyWalletMutation.data]);


  useEffect(() => {
    console.log(formErrors, "Form errors");
  }, [formErrors]);

  useEffect(() => {
    if (!walletsData) return;

    if (walletsData.data?.length > 0 || walletsData.data?.length > 0) {
      let walletsArr = walletsData?.data || [];

      walletsArr = walletsArr.filter((wallet) => wallet.currency.code == "NGN");

      setWallets(walletsArr);

      const theWallet = walletsArr[0]?.wallet_number || walletsArr[0]?.id || "";

      setSelectedWallet(theWallet);

      setFormData({ ...formData, liquidatble_wallet_number_or_uuid: theWallet })
    }

  }, [walletsData]);

  useEffect(() => {

    if (formData.fund_destination_wallet_number_or_uuid.length == 10) {

      console.log(formData.fund_destination_wallet_number_or_uuid, "the wallet account");

      verifyWalletMutation.refetch();
    }

  }, [formData.fund_destination_wallet_number_or_uuid])

  useEffect(() => {

    if (!verifyWalletMutation.error) return;

    if (!verifyWalletMutation.error.response.data.status) {

      setFormErrors({ ...formErrors, fund_destination_wallet_number_or_uuid: verifyWalletMutation.error.response.data.message })

    }

  }, [verifyWalletMutation.error])

  return (
    <div className="bg-white p-6 mr-6 rounded-2xl shadow-md">
      <h2 className="text-xl font-semibold mb-1">Liquidation Request</h2>
      <p className="text-gray-500 text-sm mb-6">
        Fill the details to request liquidation
      </p>

      {!liquidationMutation.isPending && liquidationMutation.error && (
        <Alert severity="error" className="mb-6 shadow-sm">
          {liquidationMutation.error.response.data.message}
        </Alert>
      )}

      <div className="space-y-4">
        {/* Wallet UUID/Number */}
        <div>
          <Typography
            variant="subtitle2"
            className="text-gray-700 font-semibold mb-2"
          >
            Wallet to Liquidate
          </Typography>
          <FormControl fullWidth>
            <Select
              value={selectedWallet}
              onChange={(value) => {

                if (value != undefined) {
                  setSelectedWallet(value.target.value);
                  setFormData({ ...formData, liquidatble_wallet_number_or_uuid: value.target.value })
                }

              }}
              className="bg-gray-50 border-gray-200"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#3b82f6",
                  },
                },
              }}
            >
              {wallets &&
                wallets.map((wallet) => (
                  <MenuItem
                    key={wallet.id}
                    value={wallet.wallet_number || wallet.id}
                  >
                    <div className="flex items-center gap-3 w-full">
                      <Avatar className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600">
                        <AccountBalanceWalletIcon className="text-white text-sm" />
                      </Avatar>
                      <div className="flex-1">
                        <div className="font-medium text-gray-900">
                          {wallet.currency?.code} Wallet
                        </div>
                        <div className="text-sm text-gray-500">
                          Balance: {wallet.currency?.symbol}
                          {parseFloat(
                            wallet.balance || 0
                          ).toLocaleString()}
                        </div>
                      </div>
                    </div>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>


        {/* Liquidation Type */}
        <CustomInput
          inputType="select"
          options={liquidationTypes}
          label="Liquidation Type"
          inputName="liquidation_type"
          error={formErrors?.liquidation_type}
          value={formData.liquidation_type ?? ""}
          onChange={(e) =>
            setFormData({ ...formData, liquidation_type: e.target.value })
          }
        />

        {/* Amount - only if partial */}
        {formData.liquidation_type === "partial-wallet-balance" && (
          <CustomInput
            inputType="number"
            label="Liquidation Amount"
            inputName="liquidatble_amount"
            error={formErrors?.liquidatble_amount}
            value={formData.liquidatble_amount ?? ""}
            onChange={(e) =>
              setFormData({ ...formData, liquidatble_amount: e.target.value })
            }
          />
        )}

        {/* Destination Type */}
        <CustomInput
          inputType="select"
          options={destinationTypes}
          label="Fund Destination"
          inputName="liquidated_fund_destination"
          error={formErrors?.liquidated_fund_destination}
          value={formData.liquidated_fund_destination ?? ""}
          onChange={(e) =>
            setFormData({
              ...formData,
              liquidated_fund_destination: e.target.value,
            })
          }
        />

        {/* Destination Wallet - if wallet */}
        {formData.liquidated_fund_destination === "wallet" && (
          <>
            <CustomInput
              inputType="text"
              label="Destination Wallet Number / UUID"
              inputName="fund_destination_wallet_number_or_uuid"
              error={formErrors?.fund_destination_wallet_number_or_uuid}
              value={formData.fund_destination_wallet_number_or_uuid ?? ""}
              onChange={async (e) => {

                const accountNumber = e.target.value;

                setFormData({
                  ...formData,
                  fund_destination_wallet_number_or_uuid: e.target.value,
                  fund_destination_wallet_account_name: ""
                })

                setFormErrors({
                  ...formErrors,
                  fund_destination_wallet_number_or_uuid: ""
                })

                if (accountNumber.length == 10) {

                  console.log("make request with this: ", accountNumber);
                }


              }
              }
            />

            <CustomInput
              inputType="text"
              label="Wallet Account Name"
              readOnly
              inputName="fund_destination_wallet_account_name"
              error={formErrors?.fund_destination_wallet_account_name}
              value={formData.fund_destination_wallet_account_name ?? ""}
            />

          </>
        )}

        {/* Bank Details - if nip */}
        {formData.liquidated_fund_destination === "nip" && (
          <>

            <CustomInput
              inputName={"bank_id"}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  fund_destination_bank_uuid: e.target.value,
                })
              }}
              value={formData.fund_destination_bank_uuid}
              label={"Destination Bank"}
              inputType="select"
              options={banks}
            />

            <CustomInput
              inputName={"fund_destination_bank_account_number"}
              onChange={async (e) => {

                const accountNumber = e.target.value;

                setFormData({
                  ...formData,
                  fund_destination_bank_account_number: e.target.value,
                  fund_destination_bank_account_name: ""
                })

                setFormErrors({
                  ...formErrors,
                  fund_destination_bank_account_number: ""
                })


                if (accountNumber.length == 10) {

                  console.log("make request with this: ", accountNumber);


                  const { data, error } = await verifyAccount()
                  if (error) {

                    console.log(error, "this is the error");

                    setFormErrors({ ...formErrors, fund_destination_bank_account_number: error.response.data.message })
                  } else if (data?.status) {

                    setFormData({
                      ...formData,
                      fund_destination_bank_account_name: data.data?.account_name,
                      fund_destination_bank_account_number: e.target.value,
                    })
                    return;
                  } else {
                    setFormErrors({ ...formErrors, fund_destination_bank_account_number: error.response.data.message })
                  }
                }
              }
              } value={formData.fund_destination_bank_account_number}
              label={"Account Number"}
              error={formErrors.fund_destination_bank_account_number}
              inputType="number"
            />

            <CustomInput
              inputType="text"
              label="Bank Account Name"
              readOnly
              inputName="fund_destination_bank_account_name"
              error={formErrors?.fund_destination_bank_account_name}
              value={formData.fund_destination_bank_account_name ?? ""}
            />
          </>
        )}

        {/* Description */}
        <CustomInput
          inputType="text"
          label="Description"
          inputName="liquidatble_description"
          error={formErrors?.liquidatble_description}
          value={formData.liquidatble_description ?? ""}
          onChange={(e) =>
            setFormData({
              ...formData,
              liquidatble_description: e.target.value,
            })
          }
        />

        {/* Transaction Pin */}
        <CustomInput
          inputType="password"
          label="Transaction PIN"
          inputName="transaction_pin"
          error={formErrors?.transaction_pin}
          value={formData.transaction_pin ?? ""}
          onChange={(e) =>
            setFormData({ ...formData, transaction_pin: e.target.value })
          }
        />


      </div>
      <div className="py-1" />

      {transferError && (
        <Alert severity="error" className="rounded-xl">
          {transferError}
        </Alert>
      )}
      <div className="py-3" />

      <CustomButton
        label={"Send Request"}
        onPress={handleRequest}
        isLoading={liquidationMutation.isPending}
        isEnabled={!liquidationMutation.isPending}

      />
      <div className="py-3" />

    </div>
  );
};

export default LiquidationRequest;
